<template>
    <div>
        <div class="quemjapassouaqui">
            <Container>
                <div class="quemjapassouaqui__title">
                    <h1>Algumas marcas que atendemos nestes 15 anos.</h1>
                </div>
            </Container>
            <div class="quemjapassouaqui__content">
                <WorkCategories/>
            </div>
        </div>
    </div>
</template>

<script>
import WorkCategories from '@/sections/WorkCategories'
import Container from '@/components/Container'
export default {
    name: 'quemjapassouaqui',
    components: {
        Container,
        WorkCategories,
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.quemjapassouaqui {
    padding: 9.6rem 0 13.4rem;
    @media(max-width: $max-sm) {
        padding: 3.4rem 0 1.7rem;
    }
    &__title {
        text-align: right;
        display: flex;
        justify-content: right;
        margin-bottom: 12.4rem;
        @media(max-width: $max-sm) {
            margin-bottom: 2.3rem;
        }
        h1 {
            width: 100%;
            font-size: 5rem;
            line-height: 6rem;
            font-weight: 900;
            @media(max-width: $max-sm) {
                font-size: 1.8rem;
                line-height: 2.4rem;
            }
        }
    }
    &__content {

    }
}
</style>
